<template>
  <div v-if="!isGlobal" class="help">
    <button class="help__button button button_rounded" aria-label="Help" @click="isPanelOpen = !isPanelOpen">
      <i v-if="isPanelOpen" class="icon-cancel"></i>
      <i v-else class="icon-help"></i>
    </button>

    <transition name="slide-fade">
      <div v-if="isPanelOpen" class="help__panel" v-html="langJson[lang].helpText"></div>
    </transition>
    <div class="help__panel-overlay" v-if="isPanelOpen" @click="isPanelOpen = !isPanelOpen"></div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';

  const mainStore = useMainStore();
  const lang = computed(() => mainStore.lang);
  const langJson = computed(() => mainStore.langJson);
  const isGlobal = computed(() => mainStore.isGlobal);
  const isPanelOpen = ref(false);
</script>
